import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ProcessingType } from './processing-type'

@Directive({
  selector: '[appProcessingTypeSelect]',
})
export class ProcessingTypeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.placeholder = 'ProcessingType.title'
    this.select.displayProperty = 'displayValue'
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.dataSource = enumTranslationService.enumDataSource(
      ProcessingType,
      'ProcessingType',
      false
    )
  }
}
